/** A lease owned by one Engine initialization attempt. */
export interface EngineInitLease {
    /** False after invalidate() or when a newer attempt owns initialization. */
    isCurrent(): boolean;
}

/**
 * Coordinates deduplicated, revocable Engine initialization.
 *
 * The controller deliberately knows nothing about Zustand or Engine transport.
 * Callers keep those domain concerns and use the lease to reject stale async
 * results after an Engine switch.
 */
export class EngineInitController {
    private generation = 0;
    private pending: Promise<void> | null = null;

    run(task: (lease: EngineInitLease) => Promise<void>): Promise<void> {
        if (this.pending) return this.pending;

        const generation = ++this.generation;
        const lease: EngineInitLease = {
            isCurrent: () => generation === this.generation,
        };
        let taskPromise: Promise<void>;
        try {
            taskPromise = task(lease);
        } catch (error) {
            taskPromise = Promise.reject(error);
        }
        let pending!: Promise<void>;
        pending = taskPromise.finally(() => {
            if (this.pending === pending) {
                this.pending = null;
            }
        });
        this.pending = pending;
        return pending;
    }

    invalidate(): void {
        this.generation += 1;
        this.pending = null;
    }
}
